<template>
	<div class="model_mid">
		<div class="mid_left">
			<h3>落叶期内环境监测及水肥灌溉情况</h3>
			<div class="mid_left_table_title">
				<div class="title_item" :class="{ title_item_active: activeIndex === 0 }" @click="addActive(0)">
					气象监测
				</div>
				<div class="title_item" :class="{ title_item_active: activeIndex === 1 }" @click="addActive(1)">
					土壤监测
				</div>
				<div class="title_item" :class="{ title_item_active: activeIndex === 2 }" @click="addActive(2)">
					水肥灌溉记录
				</div>
			</div>
			<wearth v-if="activeIndex===0" />
			<roil v-if="activeIndex===1" />
		    <fertilizer v-if="activeIndex===2"/>
		</div>
		<div class="mid_img">
			<img src="@/assets/period/9.png" alt="" />
		</div>
		<div class="mid_right">
			<div class="back_title"></div>
			<div class="agricultural_boder">
				<div class="agricultural">
					农事提醒：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						冬季清园，剥老翘皮，清理病虫枝叶。
					</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2025-11-1
					</div>
					<div class="agricultural_tcontent_right" style="color: red;">
						待提醒
					</div>
				</div>
				<div class="divider"></div>
			</div>
			<div class="control">
				<p>
					<sapn class="diseases">主要病虫害:</sapn>
					<sapn class="diseases_text">
						越冬病虫（白腐病、炭疽病、黑痘病、蔓枯病、霜霉病、根癌病、根结线虫等，绿盲蝽、斑衣蜡蝉等），冻害，霜害，抽条，缺素症
					</sapn>
				</p>
				<p>
					<span class="Prevention">防治措施:</span>
					<span
						class="Prevention_text">
					 清园（冬季修剪后把葡萄植株残体集中，并喷 10% （质量分数，后同）尿素水后覆膜处理或将其粉碎，再喷 2.5%的尿素水后旋耕处理），清园后可用 5 波美度石硫合剂喷枝条、水泥柱、铁丝等，防寒，埋土，培土，树干包扎，涂白，冬灌，剥树皮，刮斑衣蜡蝉卵块及介壳虫。</span>
				</p>
		
			</div>
		
		</div>
		
	</div>
	
	<div class="model_content">
			<div class="model_content_title">落叶期</div>
			<div class="model_content_date">11-01 至 12-10</div>
			<div class="model_content_text">
				阳光玫瑰葡萄的叶子开始变黄并逐渐脱落，植株进入休眠前的准备阶段。这段时间可以进行适当的修剪和清理工作，为下一个生长周期做好准备。
			</div>
		</div>
	
</template>

<script setup>
	import {
		ref
	} from 'vue';
	import wearth from './wearth/index.vue';
	import roil from './roil/index.vue';
	import fertilizer from './fertilizer/index.vue';

	let activeIndex = ref(0);

	function addActive(e) {
		activeIndex.value = e;
	}
</script>

<style lang="scss" scoped>
	.model_mid {
		width: 1840px;
		margin: 0 auto;
		height: 660px;
		background-image: url('../../../assets/model/mid-boder.png');
		background-size: 100% 100%;
		margin-top: 100px;
		display: flex;
		
		font-size: 13px;
		.mid_left {
				width: 660px;
				height: 540px;
				margin-top: 30px;
				margin-left: 30px;
				background-image: url("@/assets/model/mid-left.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding-top: 14px;
		
				h3 {
					margin-left: 40px;
					color: #2dffd0;
				}
		
				.mid_left_table_title {
					width: 60%;
					display: flex;
					font-size: 14px;
					margin: 0 auto;
					margin-top: 20px;
					justify-content: space-between;
					color: #00a580;
		
					.title_item {
						flex: 1;
						text-align: center;
						padding: 5px;
					}
		
					.title_item_active {
						background-image: url('@/assets/model/mid-left-button.png');
						color: white;
						background-size: 100% 100%;
					}
				}
		
		
		
			}
		
			.mid_img {
				margin-left: 30px;
				margin-top: 200px;
			}
		
			.mid_right {
				padding: 20px;
				width: 660px;
				height: 300px;
				margin-top: 30px;
				margin-left: 30px;
				background-image: url("@/assets/model/smallboder.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding-top: 14px;
		
				.back_title {
					height: 28px;
					width: 620px;
					background-image: url("@/assets/model/smalltitle.png");
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
		
				.agricultural_boder {
					font-size: 12px;
					.agricultural {
						color: #72a39f;
						margin-top: 20px;
						margin-left: 15px;
					}
		
					.agricultural_tcontent {
						width: 620px;
						display: flex;
						color: #007e62;
						margin-top: 10px;
						align-items: center;
						/* 垂直居中 */
						justify-content: space-between;
						/* 水平两端对齐 */
						padding-left: 15px;
		
						.agricultural_tcontent_left {
							text-align: justify;
							width: 350px;
						}
		
					}
		
					.divider {
						height: 2px;
						width: 100%;
						margin-top: 20px;
						background: linear-gradient(to right, transparent, #00796B, transparent);
					}
				}
		
				.control {
					color: white;
					margin-top: 20px;
					width: 100%;
					padding-left: 15px;
					text-align: justify;
					font-size: 14px;
		
		
					p {
						display: flex;
						justify-content: flex-start;
						padding-top: 15px;
					}
		
					.diseases {
						display: inline-block;
						width: 80px;
						color: #97cac8;
						text-align: right;
		
					}
		
					.diseases_text {
						display: inline-block;
						width: 520px;
						line-height: 20px;
						color: #007e62;
						padding-left: 20px;
					}
		
					.Prevention {
						display: inline-block;
						width: 80px;
						color: #97cac8;
						text-align: right;
					}
		
					.Prevention_text {
						display: inline-block;
						width: 520px;
						color: #007e62;
						line-height: 20px;
						padding-left: 20px;
					}
		
		
		
				}
		
			}

	}
	
	.model_content {
		width: 685px;
		height: 100px;
		margin: 0px auto;
		text-align: center;
		color: white;
		margin-top: -60px;
	
		.model_content_title {
			color: #23c9a4;
			font-size: 18px;
			font-weight: bold;
		}
	
		.model_content_date {
			margin-top: 10px;
			color: white;
			font-size: 16px;
			color: #23c9a4;
			font-weight: bold;
		}
	
		.model_content_text {
			margin-top: 10px;
			color: #23c9a4;
		}
	}
	
	
</style>